import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import WebQuestionRenderer from "./components/WebQuestionRenderer";
import { getQuestionDetails } from "../../../utils/question";
import { useSelector } from "../../../store/";

import LoadingIndicator from "../../../components/ui-components/LoadingIndicator";
import WebHeader from "../../ui-components/layout/Header/WebHeader";
import WebFooter from "../../ui-components/layout/Footer/WebFooter";
import { parseQuestionId } from '@lrg/lln-quiz-common/lib/question/lib'
import { Box } from "@mui/material";

export default function WebQuestions() {
	const location = useLocation();
	const navigate = useNavigate();

	const question = useSelector((state) => state.question);

	const learner = useSelector((state) => state.learner || {});
	const publicUrl = process.env.PUBLIC_URL;
	const [loading] = React.useState(false);

	const [questionId, setQuestionId] = React.useState(
		learner?.details?.state?.currentQuestion || []
	);

	const [questionData, setQuestionData] = React.useState(question || null);
    const [percentage, setPercentage] = React.useState(0); // for percentage in footer

	React.useEffect(() => {
		if (
			learner?.details !== null &&
			(learner?.details?.answer || []).length === 0 &&
			!learner?.details?.state?.currentQuestion
		) {
			// redirect to main
			navigate(`${publicUrl}/${location?.search || ""}`);
		}

		// for initial reload, after fetching the learner information
		if (
			learner?.details?.state?.currentQuestion &&
			questionId.length === 0
		) {
			setQuestionId(learner?.details?.state?.currentQuestion);
		}
        // setQuestionId('learning-l1q1a');
		getQData();
		setPercentage(calculateLearnerProgress({quizId: learner?.details?.testLevel, questionId: questionId}));
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [question, questionId, learner]);

	const getQData = async () => {
        const inQuestionPage = location.pathname === `${publicUrl}/question`; //location.pathname === '/question'
		
        if (learner?.showModuleBreak === true && inQuestionPage) {
			// redirect to module break page
			navigate(`${publicUrl}/continue${location?.search || ""}`);
        }
        if (learner?.showResumePage === true && inQuestionPage) {
			// redirect to module break page
			navigate(`${publicUrl}/resume${location?.search || ""}`);
        }
		setQuestionData(await getQuestionDetails(questionId));
	};

	// getting footer quiz percentage
	const calculateLearnerProgress = ({quizId, questionId}) => {
		const { skill, level, number } = parseQuestionId(questionId)
		switch (quizId) {
			case 'acsf4': {
				const skillsStartWeighting = {
					learning: 0,
					reading: 20,
					writing: 40,
					oralcommunication: 60,
					numeracy: 80,
				}
				const progression = {
					'1': [0, 3, 6, 10],
					'2': [0, 3, 6, 8],
					'3': [0, 2, 5, 9],
					'4': [0, 1, 2, 3, 3, 3],
				}

				let progress = skillsStartWeighting[skill]

				// eslint-disable-next-line default-case
				switch (level) {
					case 2:
					progress += progression[2][number - 1]
					break
					case 1:
					progress += progression[2][3]
					progress += progression[1][number - 1]
					break
					case 3:
					progress += progression[2][3]
					progress += progression[3][number - 1]
					break
					case 4:
					progress += progression[2][3]
					progress += progression[3][3]
					progress += progression[4][number - 1]
					break
				}
				return progress
			}
			case 'vfh': {
				return (number - 1) / 15 * 50 + (skill === 'numeracy' ? 50 : 0)
			}
			default: {
				return 0
			}
		}
	}

	return (
		<React.Fragment>
			{/* Header */}
            <WebHeader question={{
						...question,
						questionData:
							Object.keys(questionData).length > 0
								? questionData
								: question.questionData,
					}}/>
			{/* Boxy */}
			{!learner?.showModuleBreak && loading && <LoadingIndicator />}
			{!learner?.showModuleBreak && (
				<Box sx={{
					flexGrow: "1",
					display: "flex",
					flexDirection: "row",
				}}>
					<WebQuestionRenderer
						question={{
							...question,
							questionData:
								Object.keys(questionData).length > 0
									? questionData
									: question.questionData,
						}}
						nextQuestion={(e) => setQuestionId(e)}
					/>
				</Box>
			)}
			{/* Footer */}
            <WebFooter percentage={percentage}/>
		</React.Fragment>
	);
}